import React, { FC, useContext } from 'react';
import LoadingPage from '../../common/LoadingPage';
import TeamIcon from '../../common/teamIcon/TeamIcon';
import { DataContext } from '../../context/dataLoader/DataLoader';

import './ElectionViewer.scss';

const ElectionViewer: FC = () => {

    const { electionData, teamCollections } = useContext(DataContext)

    if (!teamCollections || !electionData) {
        return <LoadingPage />
    }

    const { teamsById, allTeams } = teamCollections;

    const { topPicksByBlessing, topPicksByTeam } = electionData;

    console.log(topPicksByTeam)

    topPicksByBlessing.sort((a, b) => b.teams.length - a.teams.length)

    return <div className='Page'>
        <div className="ElectionContents">

            {
                topPicksByBlessing.map((data, idx) => {
                    const { blessing, teams } = data;
                    return (
                        <div key={idx} className="blessingRow">
                            <div className="titles">
                                <span className='name'>{blessing.name}</span>
                                <span className='desc'>{blessing.description}</span>
                            </div>
                            <div className="teams">

                                {teams.map((teamData, idx2) => {
                                    const team = teamsById[teamData.team];
                                    const rank = teamData.rank;
                                    const color = (rank === 1) ? "gold" : (rank === 2) ? "silver" : "coral"
                                    const style: React.CSSProperties = {
                                        borderRadius: "100%",
                                        boxShadow: "0 0 6px 6px " + color
                                    }
                                    return <div className="blessingIcon" style={style}>

                                        <TeamIcon key={idx2} emoji={team.emoji} color={team.primaryColor} shape="Small Circle" />
                                    </div>
                                })}
                            </div>
                        </div>
                    )
                })
            }
            <hr />

            {
                allTeams.map((team, idx) => {
                    const picks = topPicksByTeam[team.id];
                    return (
                        <div key={idx} className="teamRow">
                            <div className="title">
                                <TeamIcon emoji={team.emoji} color={team.primaryColor} shape="Small Circle" />
                                <div className="name">{team.name}</div>

                            </div>
                            <div className="blessingList">
                                {picks.map(pick => pick.name).join(", ")}
                            </div>
                        </div>
                    )
                })
            }

        </div>
    </div>
}

export default ElectionViewer;